import { QUEUE_OPTIMIZATION_STATUS } from '../queue-optimization/queue-optimization.interface';
import type { QueueOptimizationCompletedPayload } from '../servicebus/queue-optimization';
import { ObjectFactory } from './object.factory';

export class QueueOptimizationCompletedPayloadFactory extends ObjectFactory<QueueOptimizationCompletedPayload> {
  protected getDefaults(): QueueOptimizationCompletedPayload {
    return {
      driverId: 'aabbccddeeff001122334455',
      runId: 'bbccddeeff001122334455aa',
      status: QUEUE_OPTIMIZATION_STATUS.READY,
    };
  }
}

// Pre-instantiated for convenience
export const queueOptimizationCompletedPayloadFactory = new QueueOptimizationCompletedPayloadFactory();
